const $inject = [
  "$uibModalInstance",
  "message"
];

class HmrErrorModalController {
  /**
   * @constructor
   * @param $uibModalInstance
   * @param message
   */
  constructor(
    $uibModalInstance,
    message
  ) {
    this.$uibModalInstance = $uibModalInstance;
    this.message = message;
  }

  /**
   * Close the modal
   */
  cancel() {
    this.$uibModalInstance.dismiss("cancel");
  }
}

HmrErrorModalController.$inject = $inject;

export default HmrErrorModalController;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/features/referral/controllers/modals/error.controller.js
 **/